import React, { Component } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import './style.css';

export default class PeopleSearcher extends Component {
  constructor() {
    super();
    const queryStrings = queryString.parse(location.search);
    this.state = {
      keyword: decodeURI(queryStrings.keyword ? queryStrings.keyword : ''),
    };
  }

  render() {
    return (
      <form action="/link-up/peoplesearch" method="get">
        <div className="header-search">
          <label className="header-search-label" htmlFor="keyword">
            <i className="fa fa-search header-search-icon"></i>
          </label>
          <input
            id="keyword"
            className="header-search-input"
            value={this.state.keyword}
            type="text"
            placeholder="People Search"
            name="keyword"
            onKeyPress={(e) => {
              if (e.charCode === 13) {
                e.preventDefault();
                location.href = `/link-up/peoplesearch?keyword=${this.state.keyword.trim()}`;
              }
            }}
            onChange={(e) => {
              this.setState({
                keyword: e.target.value,
              });
            }}
            onFocus={this.props.handleSearchFocus}
            onBlur={this.props.handleSearchFocus}
          />
        </div>
      </form>
    );
  }
}
const propTypes = {
  history: PropTypes.object,
  handleSearchFocus: PropTypes.func,
};
PeopleSearcher.propTypes = propTypes;



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/components/Header/components/PeopleSearcher/index.js
 **/